module.exports = __webpack_public_path__ + "img/celeri_branche.f16f8778.jpeg";